var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "data-uuid=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.property : depth0)) != null ? stack1.uuid : stack1), depth0))
    + "\"";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "        <h4 class=\"sda-h4 sda-assign-property-name\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.property : depth0)) != null ? stack1.name : stack1), depth0))
    + "</h4>\n        <a class=\"sda-assign-property-delete\"><i class=\"fa-times\"></i></a>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "            <h4 class=\"sda-h4 sda-assign-property-name\">GLOBAL</h4>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "            <li class=\"sda-assign-property-context-role "
    + alias2(alias1((depth0 != null ? depth0.status : depth0), depth0))
    + "\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"sda-assign-property\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.property : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.property : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data})) != null ? stack1 : "")
    + "\n    <ul class=\"sda-assign-property-context-roles\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.roles : depth0),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </ul>\n</div>\n";
},"useData":true});